import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Groups from "@/pages/Groups";
import GroupHome from "@/pages/GroupHome";
import Cantieri from "@/pages/Cantieri";
import CantiereDetail from "@/pages/CantiereDetail";
import ChangePassword from "@/pages/ChangePassword";
import RigaDetail from "@/pages/RigaDetail";

// Route pesanti in code-splitting
const Users = lazy(() => import("@/pages/Users"));
const Anagrafica = lazy(() => import("@/pages/Anagrafica"));
const AnagraficaSubappaltatori = lazy(() => import("@/pages/AnagraficaSubappaltatori"));
const ImportXlsx = lazy(() => import("@/pages/ImportXlsx"));
const ImportXpwe = lazy(() => import("@/pages/ImportXpwe"));
const ImportExcelAnalisi = lazy(() => import("@/pages/ImportExcelAnalisi"));
const CalendarioMateriali = lazy(() => import("@/pages/CalendarioMateriali"));
const TicketsBoard = lazy(() => import("@/pages/TicketsBoard").then(m => ({ default: m.TicketsBoard })));
const DocumentiPage = lazy(() => import("@/pages/GroupPages").then(m => ({ default: m.DocumentiPage })));
const GroupDashboard = lazy(() => import("@/pages/GroupPages").then(m => ({ default: m.GroupDashboard })));
const Subappaltatori = lazy(() => import("@/pages/Subappaltatori"));
const AndamentoCantieri = lazy(() => import("@/pages/AndamentoCantieri"));
const AnalisiPrezzi = lazy(() => import("@/pages/AnalisiPrezzi"));
const AssistenteInviluppo = lazy(() => import("@/pages/AssistenteInviluppo"));
const QuadernoCentrale = lazy(() => import("@/pages/QuadernoCentrale"));
const PortaleSubTicket = lazy(() => import("@/pages/PortaleSubTicket"));
const PortaleCantieri = lazy(() => import("@/pages/PortaleCantieri"));
const PortaleCantiereDetail = lazy(() => import("@/pages/PortaleCantiereDetail"));

const PageFallback = () => <div className="p-8 text-slate-500">Caricamento…</div>;
const L = (Comp, extra = {}) => <Suspense fallback={<PageFallback />}><Comp {...extra} /></Suspense>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route path="/" element={<Groups />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/g/:groupId" element={<GroupHome />} />
            <Route path="/g/:groupId/cantieri" element={<Cantieri />} />
            <Route path="/g/:groupId/cantieri/:id" element={<CantiereDetail />} />
            <Route path="/g/:groupId/cantieri/:id/import" element={L(ImportXlsx)} />
            <Route path="/g/:groupId/cantieri/:id/import-xpwe" element={L(ImportXpwe)} />
            <Route path="/g/:groupId/cantieri/:id/import-excel-analisi" element={L(ImportExcelAnalisi)} />
            <Route path="/g/:groupId/cantieri/:id/righe/:rigaId" element={<RigaDetail />} />
            <Route path="/g/:groupId/ticket-tecnici" element={L(TicketsBoard, { tipo: "tecnico" })} />
            <Route path="/g/:groupId/ticket-subappaltatori" element={L(TicketsBoard, { tipo: "subappaltatore" })} />
            <Route path="/g/:groupId/calendario" element={L(CalendarioMateriali)} />
            <Route path="/g/:groupId/documenti" element={L(DocumentiPage)} />
            <Route path="/g/:groupId/dashboard" element={L(GroupDashboard)} />
            <Route path="/admin/users" element={<ProtectedRoute adminOnly>{L(Users)}</ProtectedRoute>} />
            <Route path="/admin/anagrafica" element={<ProtectedRoute adminOnly>{L(Anagrafica)}</ProtectedRoute>} />
            <Route path="/admin/anagrafica-subappaltatori" element={<ProtectedRoute adminOnly>{L(AnagraficaSubappaltatori)}</ProtectedRoute>} />
            <Route path="/subappaltatori" element={L(Subappaltatori)} />
            <Route path="/subappaltatori/:subId" element={L(Subappaltatori)} />
            <Route path="/andamento" element={L(AndamentoCantieri)} />
            <Route path="/analisi-prezzi" element={L(AnalisiPrezzi)} />
            <Route path="/quaderno" element={L(QuadernoCentrale)} />
            <Route path="/assistant" element={L(AssistenteInviluppo)} />
            <Route path="/portale/ticket" element={L(PortaleSubTicket)} />
            <Route path="/portale/cantieri" element={L(PortaleCantieri)} />
            <Route path="/portale/cantieri/:id" element={L(PortaleCantiereDetail)} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
export default App;
